export default __webpack_public_path__ + "static/media/Cake.ac5acf65.svg";